var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioControlBody"},[_c('audio',{ref:"music",attrs:{"src":"/static/mp3/notify.wav","controls":"controls","loop":"","hidden":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }